import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../services/auth/auth.service';
import { NavigationService } from '../../services/navigation/navigation.service';

@Injectable()
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private navigationService: NavigationService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (environment.disableGuards) {
      return true;
    }

    if (this.authService.isAuthenticated() && !sessionStorage.getItem('second-holder')) {
      return true;
    } else if (
      this.authService.isAuthenticated() &&
      !!sessionStorage.getItem('second-holder')
    ) {
      this.navigationService.redirectSummarySecondHolder();
      return false;
    }

    this.navigationService.redirectToPreSimulator();
    return false;
  }
}
